// @flow

import {type RecordFactory, type RecordInstance, Map, Record} from 'immutable';

import {type SearchActions, RECEIVE_SEARCH_LIST} from './actions';

import {setNormalizedList} from 'app/utils/redux_v2';
import type {SearchItemType} from 'app/search/types';
import type {ResponseType} from 'app/utils/redux_v2';

type StateShape = {
  byId: Map<string, RecordInstance<SearchItemType>>,
  queries: Map<string, ResponseType<string>>,
};

const StateFactory: RecordFactory<StateShape> = Record({
  byId: Map(),
  queries: Map(),
});

export type RecordOfSearchState = RecordInstance<StateShape>;

export const search = (
  state: RecordOfSearchState = StateFactory(),
  action: SearchActions
) => {
  switch (action.type) {
    case RECEIVE_SEARCH_LIST:
      // $FlowFixMe - setIn doesnt want to work
      return setNormalizedList(action.query, action.response, state).setIn(
        ['counters', JSON.stringify(action.query)],
        action.response.count
      );

    default:
      return state;
  }
};
